(function () {
  'use strict';
  var configNode = document.getElementById('htlMobileJourneyConfig');
  if (!configNode) return;
  var textEntities = {'&amp;':'&', '&lt;':'<', '&gt;':'>', '&quot;':'"', '&#39;':"'", '&#x27;':"'", '&apos;':"'"};
  var config = JSON.parse(configNode.textContent, function(key, value) {
    return typeof value === 'string' ? value.replace(/&(?:amp|lt|gt|quot|#39|#x27|apos);/g, function(entity) {
      return textEntities[entity];
    }) : value;
  });
  var copy = config.copy;
  if (copy.simple && matchMedia('(max-width:798px)').matches) {
    var simple = copy.simple;
    function replaceText(selector,text) {
      var node=document.querySelector(selector);
      if(node) node.textContent=text;
    }
    function fold(node,label) {
      if(!node) return;
      var details=document.createElement('details'),summary=document.createElement('summary');
      details.className='htl-simple-details';summary.textContent=label;
      node.before(details);details.appendChild(summary);details.appendChild(node);
      return details;
    }
    document.querySelectorAll('.htl-card-more').forEach(function(details){details.open=false;});
    fold(document.querySelector('.htl-next-step'),simple.purchase_details);
    fold(document.querySelector('.htl-quality-proof'),simple.quality_details);
    document.querySelectorAll('.htl-showroom-proof__details>div:not(.htl-showroom-proof__visit)').forEach(function(node){
      var title=node.querySelector('h3');
      var details=fold(node,title ? title.textContent : simple.quality_details);
      if(details && title) title.hidden=true;
    });
    var reserveSteps=document.querySelector('.htl-enquiry-steps');
    var reserveDetails=fold(reserveSteps,simple.reserve_details);
    var reserveNote=document.querySelector('.htl-enquiry-reservation');
    if(reserveDetails && reserveNote) reserveDetails.appendChild(reserveNote);
    replaceText('.htl-enquiry-intro>p',simple.enquiry_intro);
    replaceText('.htl-showroom-proof__heading>p',simple.showroom_intro);
    if (!document.querySelector('[data-htl-restored-finder]')) {
    replaceText('#htlQuizModal .htl-quiz-brand',simple.finder_brand);
    var headings=[simple.capacity_title,simple.lounger_title,simple.budget_title,simple.power_title,simple.finance_title,simple.fit_title];
    headings.forEach(function(text,index){replaceText('#htlQuizModal [data-step="'+index+'"] .htl-quiz-title',text);});
    replaceText('#htlQuizModal [data-step="0"] .htl-quiz-text',simple.finder_intro);
    replaceText('#htlQuizModal [data-step="3"] .htl-quiz-text',simple.power_hint);
    replaceText('#htlQuizModal [data-step="5"] .htl-quiz-text',simple.fit_hint);
    replaceText('#htlQuizModal [data-question="power"] [data-value="any"] strong',simple.power_unsure);
    replaceText('#htlQuizModal [data-question="power"] [data-value="finder:power:both"] strong',simple.power_both);
    replaceText('#htlQuizModal [data-question="finance"] [data-value="yes-call"] strong',simple.finance_call);
    replaceText('#htlQuizModal [data-question="finance"] [data-value="yes-whatsapp"] strong',simple.finance_whatsapp);
    replaceText('#htlQuizModal [data-question="finance"] [data-value="no"] strong',simple.finance_no);
    replaceText('#htlQuizModal [data-question="spaceMode"] [data-value="strict"] strong',simple.fit_strict);
    replaceText('#htlQuizModal [data-question="spaceMode"] [data-value="advisory"] strong',simple.fit_advisory);
    replaceText('#htlQuizModal [data-question="spaceMode"] [data-value="skip"] strong',simple.fit_skip);
    replaceText('#htlLeadScreen .htl-quiz-title',simple.lead_title);
    replaceText('#htlLeadScreen .htl-quiz-text',simple.lead_intro);
    }
    function revealHash(hash) {
      if(!hash || hash.charAt(0)!=='#') return;
      var target=document.getElementById(hash.slice(1));
      if(!target) return;
      var parent=target.closest('details');
      while(parent){parent.open=true;parent=parent.parentElement.closest('details');}
    }
    document.addEventListener('click',function(e){var link=e.target.closest('a[href^="#"]');if(link)revealHash(link.getAttribute('href'));});
    window.addEventListener('hashchange',function(){revealHash(location.hash);});
    revealHash(location.hash);
  }
  document.querySelectorAll('#header a[href="/search"]').forEach(function(a){a.setAttribute('aria-label',copy.search);});
  document.querySelectorAll('#header a[href="/cart"]').forEach(function(a){a.setAttribute('aria-label',copy.cart);});
  var showroomForm=document.querySelector('.htl-showroom-contact__form');
  if (showroomForm && 'IntersectionObserver' in window) new IntersectionObserver(function(entries){
    if (entries[0].isIntersecting) event('htl_showroom_open',true);
  },{threshold:0.25}).observe(showroomForm);
  var seen = new Set();
  var isLive = config.role === 'main';
  function event(name, once) {
    if (once && seen.has(name)) return;
    if (once) seen.add(name);
    if (typeof window.clarity === 'function') {
      window.clarity('set', 'htl_environment', isLive ? 'live' : 'preview');
      window.clarity('set', 'htl_release', 'conversion_2026_10_11');
      if (isLive) window.clarity('event', name);
    }
  }
  document.addEventListener('htl:finder-results', function(e) {
    event(e.detail.type === 'swim_spa' ? 'htl_swim_finder_results' : 'htl_finder_results');
  });
  function kind(form) {
    if (!form) return null;
    if (form.id === 'htlLeadForm') return 'finder';
    if (form.id === 'htlSwimLeadForm') return 'swim_finder';
    if (form.matches('.htl-enquiry-form')) return 'product';
    if (form.matches('.htl-showroom-contact__form')) return 'showroom';
    if (form.id === 'htlLcForm') {
      var k = form.closest('[data-kind]');
      return k && /^(bookshowroom|swimspashow)$/.test(k.dataset.kind) ? 'showroom' : 'contact';
    }
    return null;
  }
  ['htl:finder-lead-confirmed','htl:lead-confirmed','htl:lead-attempt','htl:lead-error'].forEach(function(type) {
    document.addEventListener(type, function(e) {
      var k = kind(e.target);
      if (!k) return;
      var suffix = type.includes('confirmed') ? 'accepted' : type.includes('error') ? 'error' : 'attempt';
      event('htl_' + k + '_' + suffix, suffix === 'accepted');
    });
  });
  document.addEventListener('focusin', function(e) {
    var form = e.target.closest('form');
    var k = kind(form);
    if (k && e.target.matches('input:not([type="hidden"]),textarea,select')) event('htl_' + k + '_form_start', true);
  });
  document.addEventListener('submit', function(e) {
    var k = kind(e.target);
    if (!k || !e.target.matches('.htl-enquiry-form,.htl-showroom-contact__form')) return;
    event('htl_' + k + '_attempt');
    try { sessionStorage.setItem('htlPendingContact', JSON.stringify({kind:k,path:location.pathname,time:Date.now()})); } catch (_) {}
  }, true);
  try {
    var pending = JSON.parse(sessionStorage.getItem('htlPendingContact') || 'null');
    var nativeSuccess = document.querySelector('[data-htl-lead-confirmed],.htl-showroom-contact__success');
    if (pending && pending.path === location.pathname && Date.now() - pending.time < 1800000 && nativeSuccess) {
      if (['product','showroom'].includes(pending.kind)) event('htl_' + pending.kind + '_accepted', true);
      sessionStorage.removeItem('htlPendingContact');
    }
  } catch (_) {}
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (link) {
      var href = link.getAttribute('href') || '';
      if (href.startsWith('tel:')) event('htl_call_click');
      if (/^https:\/\/(wa\.me|api\.whatsapp\.com)\//.test(href)) event('htl_whatsapp_click');
      if (href.includes('google.com/maps')) event('htl_directions_click');
    }
  });
  var quiz = document.getElementById('htlQuizModal');
  if (quiz && !document.body.classList.contains('index')) {
    document.querySelectorAll('[onclick*="htlOpenQuiz"]').forEach(function(button) {
      var link=document.createElement('a');
      link.className=button.className;
      link.textContent=button.textContent;
      link.href='/'+location.search+'#finder';
      button.replaceWith(link);
    });
    document.querySelectorAll('[onclick*="htlOpenShowroom"]').forEach(function(button) {
      button.removeAttribute('onclick');
      button.addEventListener('click',function() {
        if (window.htlOpenLeadCapture) window.htlOpenLeadCapture('bookshowroom');
        else location.assign('/#our-showroom');
      });
    });
  }
  var lastScreen;
  function updateQuiz() {
    if (!quiz || !quiz.classList.contains('is-open')) { lastScreen = null; return; }
    event('htl_finder_open', true);
    var active = quiz.querySelector('.htl-quiz-screen.is-active');
    if (!active) return;
    var step = active.getAttribute('data-step');
    var kicker = active.querySelector('.htl-quiz-kicker');
    if (step !== null) {
      if (Number(step) < 5 && kicker) kicker.textContent = copy.step.replace('{number}', Number(step) + 1);
      event(Number(step) < 5 ? 'htl_finder_question_' + (Number(step) + 1) : 'htl_finder_fit', true);
    } else if (active.id === 'htlLeadScreen') event('htl_finder_contact', true);

    active.querySelectorAll('.htl-quiz-option').forEach(function(option) { option.setAttribute('aria-pressed', String(option.classList.contains('is-selected'))); });
    var options = active.querySelector('.htl-quiz-options');
    var next = active.querySelector('.htl-quiz-nav .htl-quiz-btn--primary');
    if (options && next) next.disabled = !options.querySelector('.is-selected');
    if (active !== lastScreen) {
      var body = quiz.querySelector('.htl-quiz-body');
      if (body) body.scrollTop = 0;
      var heading = active.querySelector('h3');
      if (heading) {
        if(!heading.id) heading.id='htl-finder-heading-'+(step !== null ? step : active.id);
        quiz.setAttribute('aria-labelledby',heading.id);
        heading.setAttribute('tabindex','-1'); heading.focus({preventScroll:true});
      }
      lastScreen = active;
    }
  }
  var modals = Array.from(document.querySelectorAll('#htlQuizModal,#htlLcOverlay,#htlShowroomModal'));
  var previousModal = null;
  var returnFocus = null;
  function updateModal() {
    var open = modals.filter(function(m) { return m.classList.contains('is-open'); }).pop();
    document.body.classList.toggle('htl-mobile-dialog-open', !!open);
    modals.forEach(function(m) {
      m.setAttribute('role','dialog'); m.setAttribute('aria-modal','true'); m.setAttribute('aria-hidden',String(!m.classList.contains('is-open')));
      var close = m.querySelector('.htl-modal-close,.htl-lc-close');
      if (close) close.setAttribute('aria-label', copy.close);
      var title = m.querySelector('h3');
      if (title && !m.hasAttribute('aria-labelledby')) { if (!title.id) title.id = m.id + '-title'; m.setAttribute('aria-labelledby',title.id); }
    });
    if (open && !previousModal) returnFocus = document.activeElement;
    if (!open && previousModal && returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
    if (open && open.id === 'htlLcOverlay') event(open.dataset.kind === 'bookshowroom' || open.dataset.kind === 'swimspashow' ? 'htl_showroom_open' : 'htl_contact_open', true);
    previousModal = open;
    updateQuiz();
  }
  modals.forEach(function(m) { new MutationObserver(updateModal).observe(m,{attributes:true,subtree:true,attributeFilter:['class','hidden']}); });
  document.addEventListener('keydown', function(e) {
    var open = previousModal;
    if (!open) return;
    if (e.key === 'Escape') { var close = open.querySelector('.htl-modal-close,.htl-lc-close'); if (close) close.click(); return; }
    if (e.key !== 'Tab') return;
    var focusable = Array.from(open.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex="0"]')).filter(function(el) { return el.getClientRects().length; });
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length-1];
    if (e.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !open.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });
  updateModal();
  var swim = document.querySelector('[data-htl-swim]');
  if (swim) new MutationObserver(function() {
    var panel = swim.querySelector('.htl-swim-questions');
    if (panel && !panel.hidden) { event('htl_swim_finder_open',true); var step = panel.querySelector('[data-swim-step]:not([hidden])'); if (step) event('htl_swim_finder_question_'+(Number(step.dataset.swimStep)+1),true); }
    var lead = swim.querySelector('[data-swim-lead]');
    if (lead && !lead.hidden) event('htl_swim_finder_contact',true);
  }).observe(swim,{attributes:true,subtree:true,attributeFilter:['hidden']});
  var enquiry = document.querySelector('.htl-product-enquiry');
  if (enquiry) {
    document.body.classList.add('htl-has-product-actions');
    event('htl_product_view',true);
    document.addEventListener('change',function(e) {
      if (!e.target.matches('[data-enquiry-variant]')) return;
      var option=e.target.selectedOptions[0];
      var media=option.dataset.mediaId;
      var thumb=media && document.querySelector('[data-product-gallery-thumbnails] [data-media-id="'+media+'"]');
      var gallery=document.querySelector('[data-product-gallery]');
      var carousel=gallery && window.Flickity && window.Flickity.data(gallery);
      if (!carousel && gallery && window.jQuery) carousel=window.jQuery(gallery).data('flickity');
      if (carousel && media) carousel.selectCell('[data-media-id="'+media+'"]', false, true);
      else if (thumb) thumb.click();
      var price=document.querySelector('[data-htl-mobile-price]');
      if(price && option.dataset.price) price.textContent=option.dataset.price;
      event('htl_product_colour_change');
    });
    var submit=enquiry.querySelector('[type="submit"]');
    if (submit && 'IntersectionObserver' in window) new IntersectionObserver(function(entries) {
      document.body.classList.toggle('htl-product-form-visible',entries[0].isIntersecting);
    },{threshold:0.5}).observe(submit);
  }
  var eliteText=document.querySelector('.htl-elite-hero__text');
  if (eliteText && matchMedia('(max-width:798px)').matches) {
    var details=document.createElement('details'), summary=document.createElement('summary');
    details.className='htl-mobile-range-details'; summary.textContent=copy.elite_details; details.appendChild(summary);
    eliteText.before(details); details.appendChild(eliteText);
    var features=document.querySelector('.htl-elite-hero__features'); if(features) details.appendChild(features);
  }
  event('htl_journey_view',true);
})();


